import PropTypes from 'prop-types';

const propType = {
  tax: PropTypes.number,
  price: PropTypes.number,
  total: PropTypes.number,
  vat: PropTypes.number,
  rate: PropTypes.number,
  code: PropTypes.string,
  symbol: PropTypes.string,
  billingCountry: PropTypes.string,
  userCountry: PropTypes.string,
  billingType: PropTypes.string,
  priceWithoutVAT: PropTypes.bool,
};

export default { propType };
